import defaultLang from './defaultLanguage.json'
import { I18n } from '../types'

export const defaultLanguage: I18n = defaultLang as I18n